/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  FraxCurveMagician,
  FraxCurveMagicianInterface,
} from "../FraxCurveMagician";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "_fetchersRepository",
        type: "address",
      },
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
      {
        internalType: "address",
        name: "_crv3Pool",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tricrypto2",
        type: "address",
      },
      {
        internalType: "address",
        name: "_usdc",
        type: "address",
      },
      {
        internalType: "address",
        name: "_usdt",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
      {
        internalType: "address",
        name: "_frax",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EmptyAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidCurvePriceProviderLPTokenPair",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFetchersRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidOrNotSupportedLPToken",
    type: "error",
  },
  {
    inputs: [],
    name: "Unsupported",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "coin",
        type: "address",
      },
    ],
    name: "Cached",
    type: "event",
  },
  {
    inputs: [],
    name: "CRV_3_POOL",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FETCHERS_REPO",
    outputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FRAX",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_COINS",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "QUOTE_TOKEN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TRICTYPTO_2_POOL",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDC",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDT",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "poolCoins",
    outputs: [
      {
        internalType: "address",
        name: "coin",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "index",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pools",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type FraxCurveMagicianConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: FraxCurveMagicianConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class FraxCurveMagician__factory extends ContractFactory {
  constructor(...args: FraxCurveMagicianConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "FraxCurveMagician";
  }

  deploy(
    _fetchersRepository: string,
    _priceProvidersRepository: string,
    _crv3Pool: string,
    _tricrypto2: string,
    _usdc: string,
    _usdt: string,
    _weth: string,
    _frax: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FraxCurveMagician> {
    return super.deploy(
      _fetchersRepository,
      _priceProvidersRepository,
      _crv3Pool,
      _tricrypto2,
      _usdc,
      _usdt,
      _weth,
      _frax,
      overrides || {}
    ) as Promise<FraxCurveMagician>;
  }
  getDeployTransaction(
    _fetchersRepository: string,
    _priceProvidersRepository: string,
    _crv3Pool: string,
    _tricrypto2: string,
    _usdc: string,
    _usdt: string,
    _weth: string,
    _frax: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _fetchersRepository,
      _priceProvidersRepository,
      _crv3Pool,
      _tricrypto2,
      _usdc,
      _usdt,
      _weth,
      _frax,
      overrides || {}
    );
  }
  attach(address: string): FraxCurveMagician {
    return super.attach(address) as FraxCurveMagician;
  }
  connect(signer: Signer): FraxCurveMagician__factory {
    return super.connect(signer) as FraxCurveMagician__factory;
  }
  static readonly contractName: "FraxCurveMagician";
  public readonly contractName: "FraxCurveMagician";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FraxCurveMagicianInterface {
    return new utils.Interface(_abi) as FraxCurveMagicianInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FraxCurveMagician {
    return new Contract(address, _abi, signerOrProvider) as FraxCurveMagician;
  }
}
